import {ShapeCommand} from '../commands.template';

export class ActivityChangeAttributePaddingCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  mxKey: number;
  constructor(data) {
    super(data);
    this.firstAction = true;
    this.mxKey = data.mxKey;
  }

  public execute() {
    super.execute();
    const action = {
      changeAttributePadding: {
        mxKey: Number(this.mxKey),
        attributePadding: this.object.attributePadding
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.mxKey);
  }

  public reverse() {
    super.reverse();
    const action = {
      changeAttributePadding: {
        mxKey: Number(this.mxKey),
        attributePadding: !this.object.attributePadding
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.mxKey);
  }

  private redrawActivity(activityMxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(activityMxKey))
      .comp.instance.setupFromJson();
  }
}
